// 行业
const json = [
    {
        id: 4,
        tit: '网银互联作为网络优化服务唯一供应商，正式入驻杭州跨境电商综试区',
        date: '2020-10-15',
        img: require("../../assets/about/news/hangye/20200930/20201015.png"),
        text: "近日，网银互联与中国（杭州）跨境电子商务综合试验区签订了合作协议，网银互联将作为首家网络优化服务供应商入驻综试区，届时，网银互联将为...",
        eassy:
            `
        <p>近日，网银互联与中国（杭州）跨境电子商务综合试验区签订了合作协议，网银互联将作为首家网络优化服务供应商入驻综试区，届时，网银互联将为综试区数以万计的跨境电子商务中小型企业提供保障和服务，以技术能力联动产业和生态，助力综试区共同打造“跨境电商全国第一城，全球第一流”。</p>
        <p>互联网对人们生活的渗透已无处不在，网购的出现也使得“买全球”“卖全球”不再是奢望。可随之而来的经营主体虚拟化、交易形态高度碎片化、交易范围全球化等新特点，也使得网络质量成为当下跨境电商交易的难题。在拥有47万家网络经营主体，电子商务交易额居全国城市首位的杭州，跨境电商带来的冲击更是首当其冲。</p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/hangye/20200930/1.png')}" alt=""></p>
        <p>作为我国首个跨境电商领域的综合试验区，中国（杭州）跨境电子商务综合试验区是以“线上集成＋跨境贸易＋综合服务”为主要特征的全国跨境电子商务创业创新中心、服务中心和大数据中心。试验区建设领导小组副组长佟桂莉表示，杭州作为全国首个综合试验区，将力争通过制度、管理和服务创新，破解跨境电子商务发展中的深层次矛盾和体制性难题，打造跨境电子商务完整的产业链和生态链，逐步形成一套适应和引领全球跨境电子商务发展的管理制度和规则。        </p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/hangye/20200930/2.png')}" alt=""></p>
        <p>在本次合作中，网银互联将以网络即服务（NaaS）的理念，融合软件定义网络（SDN）及广域网优化技术（WAN Optimization），以及运维保障能力，为广大的全球跨境电子商务企业提供服务。 </p> 
        <p style="text-align: center"><img src="${require('../../assets/about/news/hangye/20200930/3.png')}" alt=""></p>
        
        `
    },
    {
        id: 3,
        tit: '获阿里云“飞天生态”「精英级」伙伴，网银互联如何布局云MSP服务?',
        date: '2020-07-17',
        img: require("../../assets/about/news/hangye/20200719/20200717.png"),
        text: "继加入亚马逊云合作伙伴网络(AWS APN)之后， 2020年7月，网银互联再次获得阿里云“飞天生态合作伙伴联盟”精英级伙伴荣誉，这为网银互联...",
        eassy:
            ` 
            <p>继加入亚马逊云合作伙伴网络（AWS APN）之后， 2020年7月，网银互联再次获得阿里云“飞天生态合作伙伴联盟”精英级伙伴荣誉，这为网银互联的云MSP服务发展提供了重要的云计算发展空间。这已是网银互联加入阿里云“飞天生态”第三年了，飞天生态合作伙伴联盟，是阿里云最高级别的生态合作伙伴组织，也是对网银互联综合服务能力最高级别的肯定。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/hangye/20200719/1.png')}" alt="" style="width:600px" ></p> 
            <p class="tit" >云计算服务逐步成为企业级IT公共服务</p>
            <p>IDG公司日前发布的2020年云计算调查，涉及551位技术买家，他们全部都参与了云计算的购买过程，该调查证实了企业正在制定积极的计划：令人震惊的是，59%的受访企业表示，他们的企业将在18个月内大部分或全部使用云计算服务，并且计划将32%的IT预算用于云计算。</p>
            <p>在如今的互联网生态中，云计算平台服务已成为一种随时、随地，并根据企业按需使用的公共服务。高效的绿色数据中心以及能支持不同互联网应用的大规模分布式存储和计算是营造下一代互联网服务平台最基本的核心技术。</p>
            <p class="tit" >企业级云计算形态正在向多云趋势发展</p>
            <p>以阿里云为代表的中国云计算技术的先行者，是依托于IDC数据中心，为企业提供集约化、共享化、统一化的云计算服务，这也是目前公有云的服务模式，但在实践中被证明这种模式契合的产业较为单一，即：现有模式更加适合互联网科技型企业的需求。</p>
            <p>而随着互联网化的渗透和演进，当政府、金融、电信、能源、交通、制造业等传统行业尝试云计算服务时，单一的公有云服务模式逐渐难以满足企业多样化的需求。所以，在企业或第三方数据中心内部建设私有云也逐渐成为了更多行业更多企业用户的选择。</p>
            <p>而且随着企业数字化进程的深入和业务模式的创新，传统型、创新型企业的应用场景出现了拓展和融合。在这诸多背景下，公有云与私有云的优势和特性将成为越来越多的企业希望同时享有的模式。因此，探索能够融合公有云、私有云两种云形态优势的混合云架构，同时实现良好的协同管理，成为未来企业级云计算的必然趋势。</p>
            <p class="tit" >网银互联LinkCloud推动企业数字化转型</p>
            <p>网银互联旗下云业务品牌LinkCloud正是基于这样的趋势判断，早在2017年，从单一的IDC产业服务布局虚拟化行业，以十六年深耕的IDC基础资源为基础，整合包括阿里云、亚马逊云在内的主流云平台，结合自主研发的云连接和私有云技术（已获得国家专利认证），构建混合云、多云、数据容灾备份等IT架构一站式解决方案，帮助企业客户在使用云计算的同时降低使用门槛和IT成本，助力和推动企业数字化转型和业务发展。 </p>
            <p>通过与阿里云长久以来的合作，网银互联依托阿里云生态，与阿里云技术深度融合，打造了全流程全产业链的云时代IT服务管家，构建了以“技术+资源+服务”于一体的新型云生态体系，为企业级客户提供公有云、私有云和混合云的整体方案咨询与交付服务，致力于为全球企业客户搭建云间桥梁，让客户的IT架构更加灵活，让客户真正领略云间自由！ </p>
            `
    },
    {
        id: 2,
        tit: '聚焦两会：网络资费降15%，而这种组网方式还能再降75%！”',
        date: '2020-06-08',
        img: require("../../assets/about/news/hangye/20200608/20200608.png"),
        text: "近日，十三届全国人大三次会议指出，将降低工商业电价5%政策延长到今年年底；宽带和专线平均资费降低15%，以支持既促消费惠民生...",
        eassy:
            ` 
            <p>近日，十三届全国人大三次会议指出，将降低工商业电价5%政策延长到今年年底；宽带和专线平均资费降低15%，以支持既促消费惠民生又调结构增后劲的“两新一重”建设，加强新型基础设施建设，发展新一代信息网络，拓展5G应用，激发新消费需求、帮助中小微企业渡过疫情难关、助力产业升级。</p>
            <p>在国内疫情即将进入收尾阶段，如何帮助疫情后中小企业发展作为重要议题在本届两会中频频提出，各级政府纷纷出台相应帮扶政策支持中小企业发展。而在宽带和专线资费这一块基础通讯建设，更是大幅降低费用，普惠企业及个人用户。随着国内5G建设的日益完善，互联网快速发展，我国部分中大型企业在云计算、移动互联网、全球化趋势下，生产、研发、管理部门逐渐分离，越来越多的跨区域互联网应用（异地办公、视频会议、远程桌面、行业内信息流转等）被不断催生。</p>
            <p>而事实上，随着企业规模的扩张，分支机构的拓展，数据信息量的日益庞大。传统的企业组网方式往往会让企业面临在多个节点间断线、访问慢等网络问题，最终导致沟通延时、用户不满、体验较差等问题。使用传统方式可以缓解客户的需求压力，但是在某些情况下，对企业的运营者和IT部门而言，依然存在一些顾虑。</p>
            <p>据第三方数据统计：企业内部各分支机构互联流量逐年增加，且每年增长30%+，因而企业互联成本较高；传统网络和增值业务部署周期较长（很多长达3个月以上），很多服务网络部署流程复杂、手工配置效率低、硬件设备堆叠；传统组网方式链路利用率低（普遍<60%），关键应用体验差：由于是链路承载各种应用，传统服务中应用不可视，发生流量冲突，关键应用体验难保障。</p>
            <p>网银互联推出的LinkWAN企业互联方案，有效解决企业组网需求企业跨区域组网场景下，对应传统线路的局限性，LinkWAN服务可以提供有效的解决方案。且资费更低，同样规模的企业组网方案，如果使用LinkWAN进行互联，实际产生费用最多可达到专线的15%。</p>
            <p>网银LinkWAN服务是基于网银互联全球覆盖的骨干链路网络资源基础上，采用基于POP云端网络架构（On-POP-Overlay架构）设计研发、部署三网（已实现电信、移动、联通三网接入）自研的SD-WAN平台，为企业提供较与传统组网方式更高效快捷的云化SD-WAN服务。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/hangye/20200608/1.png')}" alt=""></p> 
            <p>通过客户专享属地服务，助力用户快速构建云、数据中心、企业分支之间的专属广域网络。同时，LinkWAN附带有自研的NMS网络管理系统，可实时监控、管理、调用组网资源，为企业提供专属广域网接入、多地组网、灵活配置以及智能调度与管理服务。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/hangye/20200608/2.png')}" alt=""></p> 
            <p>对于企业跨域多分支机构互联，LinkWAN通过使用SD-WAN产品，可实现总部-分支之间的通过广域网进行互联。在SD-WAN网络实例配置中，企业可自定义各个节点之间的互通关系，灵活组网。而对于企业分支互联的同时上云，可以通过将SD-WAN云服务产品实例与云间高速绑定，即可在企业总部-分支互联能力基础上，轻松实现企业总部-分支访问混合云资源功能（目前网银互联已覆盖全球90%以上的公有云资源，可实时接入）。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/hangye/20200608/3.png')}" alt=""></p> 
            <p>对于就要需要在OA\ERP\CRM等系统建立在国外的云服务上的企业，LinkWAN所拥有的的海外专线及全球骨干网优势，能高效实现SaaS加速，并可实现国内外智能分流，解决沟通、办公、内网访问等需求，包括且不限于Salesforce、Office365、SKYPE for business、AWS chime、Webex等全球办公、沟通软件。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/hangye/20200608/3.png')}" alt=""></p> 
            <p>分支机构广域网边缘功能的市场正在持续从专用路由、安全和广域网优化设备转向功能丰富的软件定义广域网。而LinkWAN产品以创新的SD-WAN技术在边缘计算应用中正在取代网关，并在多个连接、集中编排、原生安全性等功能中屡建奇功。</p>
           
            `
    },
    {
        id: 1,
        tit: '2020浙江启动20个大型数据中心建设，大力推进数字“新基建”',
        date: '2020-05-20',
        img: require("../../assets/about/news/hangye/20200520/20200520.png"),
        text: "近日，在浙江省十三届人大常委会第二十一次会议上，浙江省人民政府副省长高兴夫在作关于该省数字经济发展情况的报告时称，浙江将超前布局5G网络、大数据中心、人工智能等新型基础设施...",
        eassy:
            ` 
            <p>近日，在浙江省十三届人大常委会第二十一次会议上，浙江省人民政府副省长高兴夫在作关于该省数字经济发展情况的报告时称，浙江将超前布局5G网络、大数据中心、人工智能等新型基础设施，今年重点启动20个大型数据中心项目建设，建成5万个5G基站。</p>
            <h2 class="tit">敲黑板——何为新基建？</h2>
            <p>新型基础设施建设，主要包括5G基站建设、特高压、城际高速铁路和城市轨道交通、新能源汽车充电桩、大数据中心、人工智能、工业互联网七大领域。涉及诸多产业链，是以新发展理念为引领，以技术创新为驱动，以信息网络为基础，面向高质量发展需要，提供数字转型、智能升级、融合创新等服务的基础设施体系。于2020年3月，中共中央政治局常务委员会召开会议正式提出，加快5G网络、数据中心等新型基础设施建设进度。</p>
            <p>2019年，浙江省获批建设首批国家数字经济创新发展试验区。目前浙江数字经济产业规模处于国内领先，其中数字经济核心产业增加值从2014年的2854亿元增长至2019年的6228.9亿元，年均增长16.9%，培育了一大批数字经济引领型企业。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news//hangye/20200520/11.png')}" alt=""></p> 
            <p>与此同时，浙江正加快推进数字“新基建”。他提到，目前该省的宽带浙江、云上浙江建设成效明显，已经形成高速畅通、覆盖城乡、服务便捷的网络基础设施和服务体系。此外浙江还获批建设国内首个新型互联网交换中心，已累计建成各类数据中心190个，其中大型和超大型数据中心5个。</p>
            <p>超前布局5G网络、数据中心、人工智能等新型基础设施，统筹规划高等级绿色云数据中心建设，搭建云计算、边缘计算等多元普惠计算设施。加快推进国家(杭州)新型互联网交换中心建设，推进超级计算中心等高性能计算中心的规划建设与行业应用。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news//hangye/20200520/22.png')}" alt=""></p> 
            <p>并且，今年4月的国务院常务会议强调，要加快信息网络等“新基建”，坚持以市场投入为主，支持多元主体参与建设，加强政府引导和支持，以“一业带百业”，助力产业升级、培育新动能、带动就业创业。鼓励民营企业在“新基建”中发挥重要作用主要从三个方面发力，1、放宽民营企业参与“新基建”的准入条件；2、扩大民营企业参与“新基建”的资金来源；3、优化民营企业参与“新基建”的市场环境。</p>
            <p>以往一提到基建，人们脑海里浮现的都是大企业招投标的情景，中小企业很难分羹。但这次基建投资的内容已经完全不同。在当前形势下，推动企业复工复产，提振经济增长信心，成为首要之责，而“新基建”，就是要去构建“智慧经济”的整体框架和基础建设。这是一项非常庞大的系统工程，需要全民投入、全民参与，并动员更多民间资本来共同建设。据不完全统计，在浙江、江苏两地区面向“新基建”方向集中开工的重大项目中，浙江537个重大项目中，民间投资项目402个，占到了总投资额的74.86%。</p>
            <p>至2022年，县城以上城市和重点区域实现5G网络全覆盖，关键基础设施IPv6改造率达到80%。浙江今年还将重点启动20个大型数据中心项目建设，建成5万个5G基站，着力提高网络资源调度效率和智能化水平。</p>
            <p>杭州网银互联作为浙江地区的第三方IDC服务龙头企业，从2004年起深耕数据中心产业。目前拥有3座自建数据中心，主要位于杭州主城区范围，累计服务企业用户超过1200家，同时也帮助大型企业客户建设整体独立的数据中心，对于数据中心的建设与运营拥有丰富的实战经验。网银互联能够为政府与企业提供数据中心建设运营全流程的专家服务，并以专业的运维能力为数据中心用户提供数据业务保障。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news//hangye/20200520/33.png')}" alt=""></p> 


            `
    },

    {
        id: 0,
        tit: "【Q&A干货分享】敲重点，等保灵魂20问",
        text: "《【Q&A干货分享】敲重点，等保灵魂20问》--随着国内疫情防控取得积极成效，企业逐步复工复产,等保合规也重新提上重要日程...",
        date: "2020-04-02",
        img: require("../../assets/about/news/hangye/20200402/20200402.png"),
        eassy:
            `
            <p>随着国内疫情防控取得积极成效，企业逐步复工复产，等保合规也重新提上重要日程。自去年12月1日，我国《信息安全等级保护管理办法》正式进入2.0时代，但目前传统的等保安全产品，市面上产品繁多，且施工复杂、交付周期长、服务质量参差不齐。</p>
            <p>为了让有过保需求的客户能够更全面地了解当前的等保测评机制、以及针对性进行等保合规建设，网银互联安全专家服务团队梳理了等保常见20个问题，以供参考。</p>
            <p style="font-weight:bold;color:#007aaa">Q1：什么是等级保护？</p>
            <P>答：等级保护是我们国家的基本网络安全制度、基本国策，也是一套完整和完善的网络安全管理体系。 等级保护的核心是对国家重要信息、法人和其他组织及公民的专有信息以及公开信息和存储、传输、处理这些信息的信息系统分等级实行安全保护，保障信息安全和系统安全正常运行，维护国家利益、公共利益和社会稳定。</P>
            <p style="font-weight:bold;color:#007aaa">Q2：什么是等保2.0？</p>
            <P>答：国家于2019年12月1日发布等保2.0，全称网络安全等级保护2.0制度，是我国网络安全领域的基本国策、基本制度，注重主动防御，从被动防御到事前、事中、事后全流程的安全可信、动态感知和全面审计，实现了对传统信息系统、基础信息网络、云计算、大数据、物联网、移动互联网和工业控制信息系统等级保护对象的全覆盖。</P>
            <p style="font-weight:bold;color:#007aaa">Q3：为什么要做等保？</p>
            <P>答：主要有三大原因：法律法规要求、行业要求、企业系统安全需求。但严格来说，最主要的原因是：法律法规要求——《网络安全法》明确规定信息系统运营、使用单位应当按照网络安全等级保护制度要求，履行安全保护义务，如果拒不履行，将会受到相应处罚。如果达到了法律法规要求的条件，<span style="font-weight:bold">不做等保就是违法!</span></P>
            <p style="font-weight:bold;color:#007aaa">Q4：可以不做等级保护吗？</p>
            <P>答：《中华人民共和国网络安全法》第二十一条规定网络运营者应当按照网络安全等级保护制度的要求，履行相关的安全保护义务。同时第七十六条定义了网络运营者是指网络的所有者、管理者和网络服务提供者。Q2：</P>
            <p style="font-weight:bold;color:#007aaa">Q5：哪些行业必须做等保？</p>
            <P>答：教育行业、医疗行业、金融行业、物流行业、游戏行业、出版行业、国资行业、电商行业、网贷行业、通讯行业、能源行业等。
            等级保护相关标准虽然为非强制性的推荐标准，但网络（个人与家庭网络除外）运营者必须按网络安全法开展等级保护工作。</P>
            <p style="font-weight:bold;color:#007aaa">Q6：等保一共分为几级？</p>
            <P>答：第一级（自主保护级）、第二级（指导保护级）、第三级（监督保护级）、第四级（强制保护级）、第五级（专控保护级）。一般企业过二级、三级等保即可，金融类需四级等保。</P>
            <p style="font-weight:bold;color:#007aaa">Q7：如何确定企业的业务系统属于等保几级？</p>
            <P>答：可参照等级保护定级指南，从业务系统安全和系统服务安全两个方面评价当业务系统被破坏时对客体的影响程度，取两个方面较高的等级。当确定系统级别后，可开展专家评审对系统定级合理性进行审核。如有行业主管部门制订的定级依据，可直接参照采纳行业定级标准定级。</P>
            <p style="text-align: center"><img src="${require('../../assets/about/news/hangye/20200402/2.png')}" ></p>
            <p style="font-weight:bold;color:#007aaa">Q8：是否系统定级越低越好？</p>
            <P>答：不是。可根据实际业务系统的情况参照定级标准进行定级，采用“定级过低不允许、定级过高不可取”的原则。当出现网络安全事件进行追责的时候，如因系统定级过低，需承担系统定级不合理、安全责任没有履行到位的风险。</P>
            <p style="font-weight:bold;color:#007aaa">Q9：做等级保护要多少钱？</p>
            <P>答：测评的费用是按照信息系统的数量和来计算，不同等级的测评费用不一样，也会系统规模的大小有区别。
            为避免不必要投入，欢迎咨询网银互联安全专家，制订最高性价比的解决方案来满足合规要求又达到业务系统安全保障要求。</P>
            <p style="font-weight:bold;color:#007aaa">Q10：等级保护测评一般多长时间能测完？</p>
            <P>答：一个二级或三级的系统整体持续周期1-2个月。现场测评周期一般一周左右，具体看信息系统数量及信息系统的规模，有所增减。小规模安全整改2-3周，出具报告时间一周，整体持续周期1-2个月，具体时间还要根据信息系统数量及信息系统的规模，以及测评方与被测评方的配合情况等有所增减。</P>
            <p style="font-weight:bold;color:#007aaa">Q11：等级保护测评几年做一次？</p>
            <P>答：四级信息系统要求每半年至少开展一次测评；三级信息系统要求每年至少开展一次测评；二级信息系统建议每两年开展一次测评，部分行业是明确要求每两年开展一次测评。</P>
            <p style="font-weight:bold;color:#007aaa">Q12：多长时间能拿到备案证明？</p>
            <P>答：全国各省网警管理有所差异，一般提交备案流程后，如资料完备（三级系统要求含测评报告），顺利通过审核后15个工作日即可拿到备案证明。</P>
            <p style="font-weight:bold;color:#007aaa">Q13：不同公司的业务系统整合后是否可以算一个系统？</p>
            <P>答：如果两个业务系统整合后功能高度融合，后台统一，可以认为是一个系统，只是业务功能增加，按业务系统更变申请复测即可。</P>
            <p style="font-weight:bold;color:#007aaa">Q14：买/用哪些安全产品能过等保？</p>
            <P>答：可根据实际情况，如考虑等保测评结果分数与等级、业务系统风险与防护要求等综合考虑安全通信网络防护、安全区域边界防护、安全计算环境防护、安全管理中心、安全建设与运维等投入。</P>
            <p style="font-weight:bold;color:#007aaa">Q15：等级保护有哪些规范标准？</p>
            <P>答：等级保护涉及面广，相关的安全标准、规范、指南还有很多正在编制或修订中。常用的规范标准包括但不限于如下几个：</P>
            <ul>
            <li>GB/T 31167-2014 信息安全技术 云计算服务安全指南</li>
            <li>GB/T 31168-2014 信息安全技术 云计算服务安全能力要求</li>
            <li>GB/T 36326-2018 信息技术 云计算云服务运营通用要求</li>
            <li>GB/T 25058-2010 信息安全技术 信息系统安全等级保护实施指南</li>
            <li>GB/T 25070-2019信息安全技术 网络安全等级保护安全设计技术要求</li>
            <li>GB/T 28448-2019信息安全技术 网络安全等级保护测评要求</li>
            <li>GB/T 22240-2008信息安全技术 信息系统安全等级保护定级指南</li>
            <li>GM/T 0054-2018 信息系统密码应用基本要求</li>
            <li>GB/T 35273-2020 信息安全技术 个人信息安全规范</li>
            </ul>
            <p style="font-weight:bold;color:#007aaa">Q16：等级保护步骤或流程是什么样的？</p>
            <P>答：根据信息系统等级保护相关标准，等级保护工作总共分五个阶段，分别为：信息系统定级、 信息系统备案、 系统安全建设、 信息系统开始等级测评、主管单位定期开展监督检查。</P>
            <p style="font-weight:bold;color:#007aaa">Q17：业务系统在内/专网，还需要做等保吗？</p>
            <P>答：需要。内网与专网的非涉密系统都属于等级保护范畴，虽然内/专网相对于互联网，业务系统的用户比较明确或可控，但内网不代表安全。</P>
            <p style="font-weight:bold;color:#007aaa">Q18：系统在云上，还要做等保吗？</p>
            <P>答：需要。业务上云有多种情况，如在公有云、私有云、专有云等不同属性的云上，并采用IaaS、PaaS、SaaS、IDC托管等不同服务，虽然安全责任边界发生了变化，但网络运营者的安全责任不会转移。</P>
            <p style="font-weight:bold;color:#007aaa">Q19：网银互联IDC客户如何轻松过等保？</p>
            <P>答：网银互联IDC机房已通过等级保护三级，这也是租户业务系统通过等级保护2.0测评的先决条件。网银互联与深信服合作推出，专为自运营机房客户量身定制的等保服务解决方案——【托管即合规】，该方案由等保咨询服务、深信服等保安全池两大模块构成，在传统安全产品的基础上，进一步实现了IT安全服务虚拟化、资源池化、交付敏捷、节省成本四大优势。</P>
            <p style="font-weight:bold;color:#007aaa">Q20：网银互联在等保方面可为企业提供哪些帮助？</p>
            <P>答：安全产品方面，针对等保二级和三级的要求，我们拥有包含安全管理中心、下一代防火墙、web应用防火墙、DDoS高防、数据安全网关、入侵防御、漏洞监测、IDS、IPS、堡垒机、数据库审计、日志审计等安全防护产品。
            安全服务方面，网银互联基于丰富的云上安全实践与优质的技术服务，为客户设计最佳的安全防护方案，最大化安全防护效果。提供一站式、全流程服务，免去客户多点沟通，最快4周完成合规。</P>
            <p style="text-align: center"><img src="${require('../../assets/about/news/hangye/20200402/3.png')}" ></p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/hangye/20200402/5.png')}" ></p>
           `
    }


]

export default json;


// WEBPACK FOOTER //
// ./src/view/about/newinfosC.js